import React, { useState } from 'react';
import CustomersLayer from './CustomersLayer';
import ProjectsLayer from './ProjectsLayer';
import ProjectStatusLayer from './ProjectStatusLayer';
import PlantManagementTablesLayer from './PlantManagementTablesLayer';

const tabs = [
  { key: 'customers', label: 'Customers', Component: CustomersLayer },
  { key: 'projects', label: 'Projects', Component: ProjectsLayer },
  { key: 'project-status', label: 'Project Status', Component: ProjectStatusLayer },
  { key: 'plant-rate-categories', label: 'Plant Rate Categories', Component: () => <PlantManagementTablesLayer visibleKeys={['categories']} /> },
  { key: 'plant-rate-fluids', label: 'Plant Rate Categories (Fluids)', Component: () => <PlantManagementTablesLayer visibleKeys={['fluids']} /> },
  { key: 'plant-rate-globals', label: 'Plant Rate Global Parameters', Component: () => <PlantManagementTablesLayer visibleKeys={['globals']} /> },
  { key: 'plant-rate-get-templates', label: 'Plant Rate GET Templates', Component: () => <PlantManagementTablesLayer visibleKeys={['ground-tools']} /> },
  { key: 'plant-rate-tyre-templates', label: 'Plant Rate Tyre Templates', Component: () => <PlantManagementTablesLayer visibleKeys={['tyres']} /> },
];

const ProjectTablesLayer = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const ActiveComponent = tabs.find(t => t.key === activeTab).Component;
  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map(t => (
            <li key={t.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default ProjectTablesLayer;
